/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneByline from 'base/components/standalone/Byline';

export const DynamicStandaloneByline = StandaloneByline;
export type DynamicStandaloneBylineProps = PropsFromComponent<typeof StandaloneByline>;

export const DynamicStandaloneBylineWith = (extras: DynamicStandaloneExtras): typeof StandaloneByline => {
    return function DynamicStandaloneByline(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Byline');
        return <StandaloneByline {...mergeProps({ options: { theme } }, props)} />;
    }
}